export default __webpack_public_path__ + "static/media/thumbnail.c04ce92c.webp";